import { render, staticRenderFns } from "./OceanoSteakSection.vue?vue&type=template&id=1e78e1a4&scoped=true"
import script from "./OceanoSteakSection.vue?vue&type=script&lang=ts"
export * from "./OceanoSteakSection.vue?vue&type=script&lang=ts"
import style0 from "./OceanoSteakSection.vue?vue&type=style&index=0&id=1e78e1a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e78e1a4",
  null
  
)

export default component.exports